var React = require('react');

function IconPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-phone","data-name":"Icon awesome-phone","d":"M1.089,1.441,7.183.035A1.415,1.415,0,0,1,8.794.849l2.812,6.562a1.4,1.4,0,0,1-.4,1.641L7.652,11.959A21.715,21.715,0,0,0,18.034,22.341l2.906-3.551a1.4,1.4,0,0,1,1.641-.4L29.144,21.2a1.423,1.423,0,0,1,.82,1.617L28.558,28.91A1.406,1.406,0,0,1,27.187,30,27.184,27.184,0,0,1,0,2.812,1.4,1.4,0,0,1,1.089,1.441Z","transform":"translate(0.001 0.001)","fill":"#fff"}));
}

IconPhone.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = IconPhone;

IconPhone.default = IconPhone;
